import { useFlag } from '@/features/unleash';

import useUser from '@/hooks/useUser';
import { useQueryStringParam } from '@/hooks/useQueryStringParam';
import useNarrativeValuationCompany from '@/pages/PublicNarrativeAuthoring/hooks/useNarrativeValuationCompany';

import NotFound from '@/pages/NotFound';
import { PublicNarrativeCreate } from './components/PublicNarrativeCreate';
import { NarrativeLayout } from './components/NarrativeLayout';

export const PublicNarrativeCreatePage = () => {
  const { getItem } = useQueryStringParam();

  const { flagsReady, enabled } = useFlag({ name: 'mono-narrative-eu-author' });
  const { data: user, queryStatus: userStatus } = useUser();

  const companyId = getItem('company');
  const { data: company, status: companyStatus } = useNarrativeValuationCompany(
    companyId as string
  );

  if (!companyId) {
    console.warn('"company" query param was not provided.');
  }

  if (!user.loggedIn || !enabled || !companyId) {
    return <NotFound />;
  }

  const getError = () => {
    return (
      userStatus === 'error' ||
      companyStatus === 'error' ||
      typeof company === 'undefined'
    );
  };

  return (
    <NarrativeLayout
      title="Create Narrative"
      isLoading={
        userStatus === 'pending' || companyStatus === 'pending' || !flagsReady
      }
      error={getError()}
    >
      {company && <PublicNarrativeCreate company={company} />}
    </NarrativeLayout>
  );
};
